// Mock data for Bhartiya Vehicles & Engineering Co. Ltd.

export const companyInfo = {
  name: "Bhartiya Vehicles & Engineering Co. Ltd.",
  tagline: "Leading Force in Fire & Safety Engineering",
  cin: "CIN: U29999DL1982PLC013041",
  certification: "ISO 9001:2015 Certified Company",
  anniversary: "100 Years of Excellence",
  phone: "+91-120-2895295",
  email: "salesservice@bhartiyavehicles.com",
  address: "A-29, Industrial Area, Site-IV, Sahibabad, Dist.-GZB (U.P.) 201010"
};

export const stats = [
  { label: "Airports Served", value: "250+" },
  { label: "Airforce Bases", value: "60+" },
  { label: "Contracts Executed", value: "$300M+", subtitle: "($250M+ executed in the last 15 years)" },
  { label: "Skilled Workforce", value: "500+" },
  { label: "Years of Experience", value: "99+" }
];

export const mission = "To be a leading force in fire and safety engineering by delivering world-class fire trucks, firefighting systems, safety equipment, and overhaul solutions with a strong commitment to innovation, reliability and the 'Make in India' vision.";

export const vision = "To become India's most trusted and globally recognized fire and safety company, setting industry benchmarks in manufacturing, technology, and emergency response solutions while driving self-reliance through indigenous manufacturing and engineering excellence.";

export const products = [
  // ARFFV (Airfield Crash Fire Tenders)
  {
    id: 1,
    category: "ARFFV",
    name: "Bharat Panther",
    description: "First Made in India, ICAO & NFPA compliant ARFFV",
    features: ["Top Speed: 115 km/h", "0-80 km/h: <35 sec", "Tank Capacity: 10,000 ltrs", "6500 l/min centrifugal pump", "6 speed automatic transmission"],
    image: "/images/3rl210ja_ChatGPT_Image_May_29_2026_03_28_40_PM.png"
  },
  {
    id: 3,
    category: "ARFFV",
    name: "Rosenbauer Rapid Intervention Vehicle",
    description: "Fast response vehicle for immediate fire suppression at airports",
    features: ["Top Speed: 120 km/h", "0-80 km/h: <28 sec", "Tank Capacity: 6,000 ltrs", "6000 l/min pump", "Automatic transmission"],
    image: "/images/4srwkowb_PHOTO-2026-06-01-16-26-54.jpg"
  },
  {
    id: 4,
    category: "ARFFV",
    name: "Rosenbauer Buffalo Supreme",
    description: "Heavy-duty vehicle designed for extreme terrain and hard conditions",
    features: ["Top Speed: 115 km/h", "0-80 km/h: <25 sec", "Tank Capacity: 6,000 ltrs", "6500 l/min pump", "Automatic transmission"],
    image: "/images/34tqo144_PHOTO-2026-06-01-16-30-37.jpg"
  },
  {
    id: 33,
    category: "ARFFV",
    name: "Bhartiya BVEL 40",
    description: "",
    features: ["Top Speed: 110 km/h", "0-80 km/h: <35 sec", "Tank Capacity: 6,000 ltrs", "4000 l/min pump", "Automatic transmission"],
    image: "/images/bmsff3pv_PHOTO-2026-06-02-14-48-36.jpg"
  },

  // Aerial Vehicles
  {
    id: 100,
    category: "Aerial Vehicles",
    name: "Hydraulic Aerial Ladder Platform",
    description: "Highly functional hydraulic vertical reach solutions designed for efficient Rescue & Fire Suppression",
    features: [
      "Ladder lengths: 22m, 24m, 28m, 32m, 34m, 44m",
      "Chassis: 4x2, 6x2, 6x4",
      "Body: aluminium / steel",
      "Water Tank: up to 4,000 ltrs (SS / GRP / PP)",
      "Foam Tank: up to 250 ltrs (SS / GRP / PP)",
      "Hose Reel: up to 60m (1\" / 40 bar)",
      "Turret: manual or remote controlled",
      "Pump: up to 6,000 l/m at 10 bar or up to 400 l/m at 40 bar",
      "Ladder Basket: automatic balancing & foldable, 300 kg carrying capacity",
      "Outriggers: 4 outriggers with auto balancing",
      "Optional: telescopic lighting projectors, up to 800 kg powder unit"
    ],
    image: "/images/IMG_7088.jpg"
  },
  {
    id: 101,
    category: "Aerial Vehicles",
    name: "Turntable Ladder",
    description: "360-degree high-angle agility for precise, rapid vertical evacuations",
    features: [
      "Ladder lengths: 24m, 28m, 32m, 42m, 44m",
      "Chassis: 4x2, 6x2, 6x4",
      "Body: aluminium / steel",
      "Water Tank: up to 4,000 ltrs (SS / GRP / PP)",
      "Foam Tank: up to 250 ltrs (SS / GRP / PP)",
      "Hose Reel: up to 60m (1\" / 40 bar)",
      "Turret: manual or remote controlled",
      "Pump: up to 6,000 l/m at 10 bar or up to 400 l/m at 40 bar",
      "Ladder Basket: automatic balancing & foldable, 300 kg carrying capacity",
      "Outriggers: 4 outriggers with auto balancing",
      "Optional: telescopic lighting projectors, up to 800 kg powder unit"
    ],
    image: "/images/IMG_7090.jpg"
  },
  {
    id: 102,
    category: "Aerial Vehicles",
    name: "Boom Tower",
    description: "Rescue Remote Controlled Foam Tower",
    features: [
      "Ladder lengths: 24m, 28m, 32m, 34m, 42m, 44m",
      "Chassis: 4x2, 6x2, 6x4",
      "Body: aluminium / steel",
      "Water Tank: up to 10,000 ltrs (SS / GRP / PP)",
      "Foam Tank: up to 1,000 ltrs (SS / GRP / PP)",
      "Hose Reel: up to 60m (1\" / 40 bar)",
      "Turret: remote controlled",
      "Pump: up to 6,000 l/m at 10 bar or up to 400 l/m at 40 bar",
      "Ladder Basket: automatic balancing & foldable, 300 kg carrying capacity",
      "Outriggers: 4 outriggers with auto balancing",
      "Optional: telescopic lighting projectors, up to 800 kg powder unit"
    ],
    image: "/images/IMG_7089.jpg"
  },
  {
    id: 103,
    category: "Aerial Vehicles",
    name: "Multipurpose Boom Tower",
    description: "Combining Remote Controlled Foam Tower with Rescue Ladder",
    features: [
      "Ladder lengths: 24m, 28m, 32m, 34m, 42m, 44m",
      "Chassis: 4x2, 6x2, 6x4",
      "Body: aluminium / steel",
      "Water Tank: up to 10,000 ltrs (SS / GRP / PP)",
      "Foam Tank: up to 1,000 ltrs (SS / GRP / PP)",
      "Hose Reel: up to 60m (1\" / 40 bar)",
      "Turret: remote controlled",
      "Pump: up to 6,000 l/m at 10 bar or up to 400 l/m at 40 bar",
      "Ladder Basket: automatic balancing & foldable, 300 kg carrying capacity",
      "Outriggers: 4 outriggers with auto balancing",
      "Optional: telescopic lighting projectors, up to 800 kg powder unit"
    ],
    image: "/images/irakgloc_IMG_7087.jpg"
  },

  // Domestic Fire Tenders
  {
    id: 8,
    category: "Domestic Fire Tenders",
    name: "Water Tender",
    description: "Based on TATA LPT / Ashok Leyland chassis with 3000-5000L capacity",
    features: ["High-pressure pump", "Quick deployment", "Versatile applications", "Low maintenance"],
    image: "/images/p1y7ehov_PHOTO-2026-06-01-16-37-29_2.jpg"
  },
  {
    id: 9,
    category: "Domestic Fire Tenders",
    name: "Foam Tender",
    description: "Specialized foam tender with water and foam concentrate tanks",
    features: ["3000-5000L water", "550-3000L foam", "Proportioning system", "Reliable performance"],
    image: "/images/p2g0ana0_PHOTO-2026-06-01-16-37-29.jpg"
  },
  {
    id: 10,
    category: "Domestic Fire Tenders",
    name: "Quick Response Vehicle",
    description: "Designed for rapid operations and emergency response",
    features: ["Fast deployment", "Compact design", "Efficient operation", "Urban optimized"],
    image: "/images/s5ovwwqf_Screenshot_2026-06-01_at_6.01.52 pm.png"
  },
  {
    id: 11,
    category: "Domestic Fire Tenders",
    name: "Dry Chemical Powder Tender",
    description: "Specialized tender for dry chemical powder fire suppression",
    features: ["250-4000 kgs capacity", "Quick discharge", "Electrical fire ready", "Efficient suppression"],
    image: "/images/81oct5bj_PHOTO-2026-06-01-16-47-10.jpg"
  },
  {
    id: 34,
    category: "Domestic Fire Tenders",
    name: "Multipurpose Tender",
    description: "Versatile fire tender combining multiple firefighting capabilities for diverse emergency scenarios",
    features: ["Multi-function capability", "High-capacity tanks", "Equipped with rescue tools", "Heavy-duty chassis"],
    image: "/images/ilgljomq_IMG_6881.jpg"
  },
  {
    id: 35,
    category: "Emergency Rescue Tender",
    name: "Emergency Rescue Tender",
    description: "Fully equipped rescue tender with comprehensive emergency response and rescue tools",
    features: ["Hydraulic rescue tools", "Power generator & lighting", "Cutting & spreading equipment", "Emergency response gear"],
    image: "/images/qvttbl6r_IMG_6883.jpg"
  },
  
  // Forest Firefighting Vehicle
  {
    id: 36,
    category: "Forest Firefighting Vehicle",
    name: "Forest Firefighting Vehicle",
    description: "Heavy-duty all-terrain forest firefighting vehicle for off-road and remote operations",
    features: ["All-terrain capability", "High-capacity water tank", "Extreme off-road performance", "Rugged construction"],
    image: "/images/fjbzq5gx_IMG_6879.jpg"
  },
  
  // Fire Protection Systems
  {
    id: 14,
    category: "Fire Protection Systems",
    subcategory: "Fire Alarm & Detection Systems",
    name: "Smoke Detector",
    description: "Advanced smoke detection for early fire warning",
    features: ["Early detection", "High sensitivity", "Reliable operation", "Easy installation"]
  },
  {
    id: 15,
    category: "Fire Protection Systems",
    subcategory: "Fire Alarm & Detection Systems",
    name: "Heat Detector",
    description: "Temperature-based fire detection system",
    features: ["Temperature monitoring", "Fast response", "Durable design", "Low maintenance"]
  },
  {
    id: 16,
    category: "Fire Protection Systems",
    subcategory: "Fire Alarm & Detection Systems",
    name: "Flame Detector",
    description: "Optical flame detection for rapid fire identification",
    features: ["Optical detection", "Fast response", "Wide coverage", "High accuracy"]
  },
  {
    id: 17,
    category: "Fire Protection Systems",
    subcategory: "Fire Alarm & Detection Systems",
    name: "Fire Alarm System",
    description: "Comprehensive fire alarm and notification system",
    features: ["Centralized control", "Multiple zones", "Audio-visual alerts", "Integrated system"]
  },
  {
    id: 18,
    category: "Fire Protection Systems",
    subcategory: "Fire Extinguishing System",
    name: "Water Extinguisher",
    description: "Water-based fire extinguishing system",
    features: ["Class A fires", "Eco-friendly", "Cost-effective", "Easy to use"]
  },
  {
    id: 19,
    category: "Fire Protection Systems",
    subcategory: "Fire Extinguishing System",
    name: "Foam Extinguisher",
    description: "Foam-based extinguisher for multiple fire types",
    features: ["Class A & B fires", "Cooling effect", "Smothering action", "Versatile use"]
  },
  {
    id: 20,
    category: "Fire Protection Systems",
    subcategory: "Fire Extinguishing System",
    name: "CO2 Extinguisher",
    description: "Carbon dioxide fire suppression system",
    features: ["Electrical fires", "No residue", "Clean agent", "Fast suppression"]
  },
  {
    id: 21,
    category: "Fire Protection Systems",
    subcategory: "Fire Extinguishing System",
    name: "Dry Chemical Powder Extinguisher",
    description: "Multi-purpose dry chemical powder extinguisher",
    features: ["Multi-class fires", "Quick action", "Wide coverage", "Reliable performance"]
  },
  {
    id: 22,
    category: "Fire Protection Systems",
    subcategory: "Fire Extinguishing System",
    name: "ABC Extinguisher",
    description: "All-purpose ABC type fire extinguisher",
    features: ["All fire classes", "Versatile use", "Effective suppression", "Standard compliance"]
  },
  {
    id: 23,
    category: "Fire Protection Systems",
    subcategory: "Fire Hydrant System",
    name: "Hydrant Valves",
    description: "Industrial fire hydrant valves and connections",
    features: ["Durable construction", "Easy operation", "Standard connections", "Reliable flow"]
  },
  {
    id: 24,
    category: "Fire Protection Systems",
    subcategory: "Fire Hydrant System",
    name: "Hose Pipes & Reels",
    description: "Fire fighting hose pipes and reel systems",
    features: ["High-pressure rated", "Easy deployment", "Durable material", "Standard fittings"]
  },
  {
    id: 25,
    category: "Fire Protection Systems",
    subcategory: "Fire Hydrant System",
    name: "Fire Pumps",
    description: "High-capacity fire fighting pumps",
    features: ["High pressure", "Reliable operation", "Auto-start capability", "Low maintenance"]
  },
  {
    id: 26,
    category: "Fire Protection Systems",
    subcategory: "Fire Hydrant System",
    name: "Piping Network",
    description: "Complete piping network for fire hydrant systems",
    features: ["Corrosion resistant", "Proper sizing", "Standard compliance", "Leak-proof joints"]
  },
  {
    id: 27,
    category: "Fire Protection Systems",
    subcategory: "Fire Sprinkler System",
    name: "Wet Pipe System",
    description: "Water-filled sprinkler system for immediate response",
    features: ["Immediate response", "Automatic operation", "Reliable coverage", "Cost-effective"]
  },
  {
    id: 28,
    category: "Fire Protection Systems",
    subcategory: "Fire Sprinkler System",
    name: "Dry Pipe System",
    description: "Pressurized air sprinkler system for cold environments",
    features: ["Freeze protection", "Cold climate ready", "Delayed discharge", "Safe operation"]
  },
  {
    id: 29,
    category: "Fire Protection Systems",
    subcategory: "Fire Sprinkler System",
    name: "Pre-Action System",
    description: "Two-stage sprinkler system for sensitive areas",
    features: ["Double protection", "False alarm prevention", "Controlled discharge", "Sensitive areas"]
  },
  {
    id: 30,
    category: "Fire Protection Systems",
    subcategory: "Fire Suppression System",
    name: "CO2 Suppression System",
    description: "Carbon dioxide fire suppression for enclosed spaces",
    features: ["Clean agent", "No residue", "Electrical protection", "Fast suppression"]
  },
  {
    id: 31,
    category: "Fire Protection Systems",
    subcategory: "Fire Suppression System",
    name: "FM-200 System",
    description: "Advanced clean agent fire suppression system",
    features: ["Clean agent", "Safe for equipment", "Fast discharge", "Environmentally friendly"]
  },
  {
    id: 32,
    category: "Fire Protection Systems",
    subcategory: "Fire Suppression System",
    name: "Foam Suppression System",
    description: "Foam-based fire suppression for flammable liquids",
    features: ["Liquid fire control", "Blanketing effect", "Vapor suppression", "Effective coverage"]
  },
  
  // Firefighter's Equipment
  {
    id: 51,
    category: "Firefighting Equipment",
    name: "RFC UHPS",
    description: "Fine atomised water/foam compound in perfect droplet size",
    features: ["Large throwing distance", "Maximum cooling effect", "Easy to use", "Standalone or portable unit"],
    image: "/images/wums5fhw_IMG_6891_2.WEBP"
  },
  {
    id: 52,
    category: "Firefighting Equipment",
    name: "RFC CAFS",
    description: "Compressed Air Foam System for universal firefighting",
    features: ["Large throwing distance", "Rapid and maximum cooling effect", "Easy to use", "Clear visible extinguishing"],
    image: "/images/lbjch73a_IMG_6892_2.WEBP"
  },
  {
    id: 53,
    category: "Firefighting Equipment",
    name: "RFC Battery Extinguishing System",
    description: "Rapid and Safe extinguishing of battery fires in electric vehicles",
    features: ["Safe to application", "Quick to deploy", "Flexible to application"],
    image: "/images/y1c6gbup_IMG_6893_2.WEBP"
  },
  {
    id: 54,
    category: "Firefighting Equipment",
    name: "RFC Cuttex",
    description: "Cutting and Extinguishing in enclosed areas",
    features: ["Increased safety for firefighters", "Quick cutting technology", "High efficiency extinguishing", "Flexible dual use"],
    image: "/images/c87p50y3_IMG_6894.WEBP"
  },
  
  // Firefighter's Equipment
  {
    id: 46,
    category: "Firefighter's Equipment",
    name: "Protective Helmet",
    description: "Heat Resistant and Impact Proof",
    features: ["Protective and Durable", "Comfortable Design", "Attachments: Goggles, Visors, Light, Communication System", "Multipurpose"],
    image: "/images/332ejwbp_helmet.jpg"
  },
  {
    id: 47,
    category: "Firefighter's Equipment",
    name: "Protective Suit",
    description: "Approach, Proximity and Entry Suits",
    features: ["Multi-Layer Thermal Protection", "Flame and Heat Resistant", "Water and Wind Proof", "Durable and Lightweight Design"],
    image: "/images/fire_suit.jpg"
  },
  {
    id: 48,
    category: "Firefighter's Equipment",
    name: "Protective Gloves",
    description: "Versatile and Comfortable",
    features: ["Flames & Heat Resistant", "Sharp Edges Resistant", "Wind and Water Resistant", "Strong Grip"],
    image: "/images/pets38d5_gloves.jpg"
  },
  {
    id: 49,
    category: "Firefighter's Equipment",
    name: "Protective Boots",
    description: "Versatile and Comfortable",
    features: ["Heat and Flame Resistant", "Steel or Composite Toe Protection", "Slip Resistant Outsole", "Waterproof Construction"],
    image: "/images/ptdsag1i_Boots.WEBP"
  },
  {
    id: 50,
    category: "Firefighter's Equipment",
    name: "Breathing Apparatus",
    description: "Reliable Respiratory Protection",
    features: ["Self-Contained Air Supply", "Positive Pressure System", "Full Face Mask Protection", "Extended Operating Duration"],
    image: "/images/m5eun0pr_breathing_apparatus.jpg"
  },
  
  // Firefighting Robots
  {
    id: 500,
    category: "Firefighting Robots",
    name: "HECTHOR",
    description: "Hecthor is a rugged next-gen autonomous tracked vehicle designed for the most demanding missions in industry, defence, search & rescue and agriculture with unmatched firefighting capabilities.",
    features: [],
    image: "/images/hector.png"
  },
  {
    id: 501,
    category: "Firefighting Robots",
    name: "MINITHOR",
    description: "Minithor is a compact unmanned ground vehicle (UGV) designed for indoor and semi-indoor operations in high-rise buildings, industrial facilities, airports, GNSS limited environments and other complex infrastructures.",
    features: [],
    image: "/images/minithor.png"
  },

  // Rescue Tools
  {
    id: 37,
    category: "Rescue Tools",
    name: "Power Saws",
    description: "High-performance rescue saws for emergency cutting operations",
    features: ["Heavy-duty cutting", "Portable design", "Reliable performance"]
  },
  {
    id: 38,
    category: "Rescue Tools",
    name: "Hydraulic Spreaders",
    description: "Powerful hydraulic spreaders for prying and opening operations",
    features: ["High force output", "Precision control", "Emergency rescue"]
  },
  {
    id: 39,
    category: "Rescue Tools",
    name: "Hydraulic Cutters",
    description: "Heavy-duty hydraulic cutters for vehicle extrication",
    features: ["Powerful cutting", "Robust construction", "Quick deployment"]
  },
  {
    id: 40,
    category: "Rescue Tools",
    name: "Hydraulic Rams",
    description: "Hydraulic rams for pushing, lifting, and extrication tasks",
    features: ["High force capacity", "Versatile operation", "Compact design"]
  },
  {
    id: 41,
    category: "Rescue Tools",
    name: "Hydraulic Power Units (HPU) / Gensets",
    description: "Power source for hydraulic rescue equipment and emergency operations",
    features: ["Reliable power supply", "Portable design", "Multi-tool support"]
  },
  {
    id: 42,
    category: "Rescue Tools",
    name: "Air Lifting Bags",
    description: "High-pressure air lifting bags for heavy lifting operations",
    features: ["High lifting capacity", "Pneumatic operation", "Safe & controlled"]
  },
  {
    id: 43,
    category: "Rescue Tools",
    name: "Rescue Jumping Cushions",
    description: "Emergency jumping cushions for evacuation from heights",
    features: ["Quick deployment", "Life-saving", "Reliable cushioning"]
  },
  {
    id: 44,
    category: "Rescue Tools",
    name: "Rescue Winches",
    description: "Heavy-duty winches for rescue and recovery operations",
    features: ["High pulling capacity", "Durable construction", "Reliable mechanism"]
  },
  {
    id: 45,
    category: "Rescue Tools",
    name: "Penetrating Nozzles",
    description: "Specialized nozzles for penetration and targeted fire suppression",
    features: ["Wall penetration", "Precision targeting", "Effective suppression"]
  },

  // Pumps
  {
    id: 600,
    category: "Pumps",
    name: "BVEL HLP 2000",
    description: "High-performance dual-pressure centrifugal fire pump delivering 2000 lpm in low pressure and 400 lpm in high pressure mode, engineered for demanding firefighting applications.",
    features: [
      "LP Capacity: 2000 lpm @ 10 bar / 2280 lpm @ 7 bar",
      "HP Capacity: 400 lpm @ 40 bar",
      "LP Power: 67 kW / 90 hp @ 2980 rpm | 52 kW / 70 hp @ 2650 rpm",
      "HP Power: 90 kW / 121 hp @ 3200 rpm",
      "Suction Inlet: 100 mm",
      "Priming Range: 0 – 7.5 m | Speed: 100 – 2500 rpm",
      "Thermal Relief Valve: 55°C – 60°C activation",
      "Dimensions (L × W × H): 735 × 505 × 647 mm"
    ],
    image: "/images/bvel_hlp_2000.jpg"
  },
  {
    id: 601,
    category: "Pumps",
    name: "BVEL HLP 3000",
    description: "High-capacity dual-pressure centrifugal fire pump delivering 3000 lpm in low pressure and 400 lpm in high pressure mode, built for high-demand firefighting operations.",
    features: [
      "LP Capacity: 3000 lpm @ 10 bar / 3200 lpm @ 7 bar",
      "HP Capacity: 400 lpm @ 40 bar",
      "LP Power: 100 kW / 134 hp @ 3200 rpm | 85 kW / 114 hp @ 3000 rpm",
      "HP Power: 90 kW / 121 hp @ 3200 rpm",
      "Suction Inlet: 140 mm",
      "Priming Range: 0 – 7.5 m | Speed: 100 – 2500 rpm",
      "Thermal Relief Valve: 55°C – 60°C activation",
      "Dimensions (L × W × H): 755 × 788 × 643 mm"
    ],
    image: "/images/bvel_hlp_3000.jpg"
  },
  {
    id: 602,
    category: "Pumps",
    name: "BVEL HLP 4000",
    description: "Heavy-duty dual-pressure centrifugal fire pump delivering 4000 lpm in low pressure and 400 lpm in high pressure mode, designed for the most demanding large-scale firefighting operations.",
    features: [
      "LP Capacity: 4000 lpm @ 10 bar / 4200 lpm @ 7 bar",
      "HP Capacity: 400 lpm @ 40 bar",
      "LP Power: 125 kW / 168 hp @ 3200 rpm | 105 kW / 140 hp @ 2850 rpm",
      "HP Power: 90 kW / 121 hp @ 3200 rpm",
      "Suction Inlet: 140 mm",
      "Priming Range: 0 – 7.5 m | Speed: 100 – 2500 rpm",
      "Thermal Relief Valve: 55°C – 60°C activation",
      "Dimensions (L × W × H): 754 × 792 × 705 mm"
    ],
    image: "/images/bvel_hlp_4000_v2.jpg"
  },
  {
    id: 603,
    category: "Pumps",
    name: "BVEL HLP 6000",
    description: "High-output dual-pressure centrifugal fire pump delivering 6000 lpm in low pressure and 400 lpm in high pressure mode, built for the largest firefighting and industrial applications.",
    features: [
      "LP Capacity: 6000 lpm @ 10 bar",
      "HP Capacity: 400 lpm @ 40 bar",
      "LP Power: 170 kW / 228 hp @ 3300 rpm",
      "HP Power: 90 kW / 121 hp @ 3200 rpm",
      "Suction Inlet: 200 mm",
      "Priming Range: 0 – 7.5 m | Speed: 100 – 2500 rpm",
      "Thermal Relief Valve: 55°C – 60°C activation",
      "Dimensions (L × W × H): 754 × 792 × 705 mm"
    ],
    image: "/images/bvel_hlp_6000.jpg"
  },
  {
    id: 604,
    category: "Pumps",
    name: "BVEL LP 2000",
    description: "Single-stage low-pressure centrifugal fire pump delivering 2000 lpm at 10 bar, compact and reliable for standard firefighting applications.",
    features: [
      "LP Capacity: 2000 lpm @ 10 bar / 2280 lpm @ 7 bar",
      "LP Power: 67 kW / 90 hp @ 2980 rpm | 52 kW / 70 hp @ 2650 rpm",
      "Suction Inlet: 100 mm",
      "Priming Range: 0 – 7.5 m | Speed: 100 – 2500 rpm",
      "Thermal Relief Valve: 55°C – 60°C activation",
      "Dimensions (L × W × H): 710 × 505 × 605 mm"
    ],
    image: "/images/bvel_lp_2000_v2.jpg"
  },
  {
    id: 605,
    category: "Pumps",
    name: "BVEL LP 3000",
    description: "High-capacity single-stage low-pressure centrifugal fire pump delivering 3000 lpm at 10 bar, engineered for demanding large-scale firefighting operations.",
    features: [
      "LP Capacity: 3000 lpm @ 10 bar / 3200 lpm @ 7 bar",
      "LP Power: 100 kW / 134 hp @ 3200 rpm | 85 kW / 114 hp @ 3000 rpm",
      "Suction Inlet: 140 mm",
      "Priming Range: 0 – 7.5 m | Speed: 100 – 2500 rpm",
      "Thermal Relief Valve: 55°C – 60°C activation",
      "Dimensions (L × W × H): 730 × 788 × 618 mm"
    ],
    image: "/images/bvel_lp_3000.jpg"
  },
  {
    id: 606,
    category: "Pumps",
    name: "BVEL LP 4000",
    description: "Heavy-duty single-stage low-pressure centrifugal fire pump delivering 4000 lpm at 10 bar, designed for the most demanding large-scale firefighting operations.",
    features: [
      "LP Capacity: 4000 lpm @ 10 bar / 4200 lpm @ 7 bar",
      "LP Power: 125 kW / 168 hp @ 3200 rpm | 105 kW / 140 hp @ 2850 rpm",
      "Suction Inlet: 140 mm",
      "Priming Range: 0 – 7.5 m | Speed: 100 – 2500 rpm",
      "Thermal Relief Valve: 55°C – 60°C activation",
      "Dimensions (L × W × H): 730 × 792 × 685 mm"
    ],
    image: "/images/bvel_lp_4000.jpg"
  },
  {
    id: 607,
    category: "Pumps",
    name: "BVEL LP 6000",
    description: "High-output single-stage low-pressure centrifugal fire pump delivering 6000 lpm at 10 bar, built for the largest industrial and municipal firefighting applications.",
    features: [
      "LP Capacity: 6000 lpm @ 10 bar",
      "LP Power: 170 kW / 228 hp @ 3300 rpm",
      "Suction Inlet: 200 mm",
      "Priming Range: 0 – 7.5 m | Speed: 100 – 2500 rpm",
      "Thermal Relief Valve: 55°C – 60°C activation",
      "Dimensions (L × W × H): 755 × 725 × 720 mm"
    ],
    image: "/images/bvel_lp_6000.jpg"
  },

  // Accessories
  {
    id: 708,
    category: "Accessories",
    name: "Water cum Foam Monitor",
    description: "CE certified 360° rotating water and foam monitor with flanged base mounting, delivering 3000 LPM with interchangeable Jet, Jet & Spray, and Super Stream nozzles.",
    features: [
      "Flow: 3000 LPM",
      "Horizontal Rotation: 360°",
      "Vertical Rotation: +75° & -15°",
      "MOC: Aluminium / Gun Metal",
      "Nozzles: Jet, Jet & Spray, Super Stream",
      "Mounting: Flanged Base",
      "Application: Water / Foam",
      "Certification: CE Certified"
    ],
    image: "/images/water_cum_foam_monitor.jpg"
  },
  {
    id: 701,
    category: "Accessories",
    name: "Multipurpose Handline Nozzles",
    description: "Advanced multipurpose handline nozzles designed for versatile firefighting operations, offering selectable flow and pattern control for maximum operational flexibility.",
    features: [
      "Dual Pressure Nozzle",
      "Constant Flow Nozzle",
      "Mid Jet Nozzle",
      "Select O Flow Nozzle",
      "Select O Max Flow Nozzle"
    ],
    image: "/images/multipurpose_handline_nozzles.jpg"
  },
  {
    id: 707,
    category: "Accessories",
    name: "Electric Rewind Hosereel",
    description: "CE certified electric rewind hosereel with 12/24V motor drive and manual override, available in MS Sheet or Stainless Steel construction for demanding firefighting applications.",
    features: [
      "Hose Size: 20 mm",
      "Hose Capacity: 60 Mtrs",
      "Working Pressure: 7 to 100 Bar",
      "Drive: 12/24V Rewind Motor / Manual",
      "Material: MS Sheet / Stainless Steel",
      "Certification: CE Certified"
    ],
    image: "/images/electric_rewind_hosereel.jpg"
  },
  {
    id: 700,
    category: "Accessories",
    name: "Handline Nozzles",
    description: "Complete range of handline nozzles for firefighting and suppression operations, covering all standard and specialist applications.",
    features: [
      "Copper Long Branch",
      "Short Branch Pipe with Nozzle",
      "Multi Purpose Nozzle",
      "Triple Purpose Nozzle",
      "Fog Nozzle",
      "Revolving Nozzle",
      "Jumbo Curtain Nozzle",
      "Water Curtain Nozzle",
      "Nozzle Spanner",
      "Pinchering Nozzle"
    ],
    image: "/images/handline_nozzles.jpg"
  },
  {
    id: 702,
    category: "Accessories",
    name: "Foam Making Branch",
    description: "Range of foam making branches and portable inline inductors for generating and applying firefighting foam across various hazard types.",
    features: [
      "Foam Making Branch FB-5X",
      "Foam Making Branch FB-10",
      "Foam Making Branch FB-10X",
      "Portable Inline Inductor"
    ],
    image: "/images/foam_making_branch.jpg"
  },
  {
    id: 703,
    category: "Accessories",
    name: "Foam Expansion Generator",
    description: "Medium and high expansion foam generators for large-area foam flooding and suppression, covering enclosed spaces, warehouses, and high-hazard applications.",
    features: [
      "Medium Expansion Foam Branch",
      "Medium Expansion Foam Generator",
      "High Expansion Foam Generator"
    ],
    image: "/images/foam_expansion_generator.jpg"
  },
  {
    id: 704,
    category: "Accessories",
    name: "Ground Monitors",
    description: "Portable ground monitors for high-volume water and foam delivery, available in standard and oscillating configurations for flexible firefighting deployment.",
    features: [
      "Portable Ground Monitor",
      "Oscillating Portable Ground Monitor"
    ],
    image: "/images/ground_monitors.jpg"
  },
  {
    id: 705,
    category: "Accessories",
    name: "Breeches",
    description: "Essential hose-line fittings for splitting and collecting water flow, available in collecting, dividing, and controlled dividing configurations.",
    features: [
      "Collecting Breech",
      "Dividing Breech",
      "Controlled Dividing Breech"
    ],
    image: "/images/breeches.jpg"
  },
  {
    id: 706,
    category: "Accessories",
    name: "Adaptors",
    description: "Comprehensive range of hose and pipe adaptors for versatile firefighting connections across all standard thread types and configurations.",
    features: [
      "International Shore Connection",
      "Flange to Round Thread Adaptor",
      "Flange to Male Inst. Adaptor",
      "Double Female",
      "Double Male",
      "Non Return Valve",
      "Shank Reducer",
      "63mm Male x 38mm Female Adaptor",
      "63mm Female x M BSPT Adaptor",
      "Suction Wrench"
    ],
    image: "/images/adaptors.jpg"
  }
];

export const solutions = [
  {
    id: 1,
    title: "Manufacturing",
    description: "State-of-the-art production of fire fighting and emergency response vehicles with advanced technology and modern infrastructure.",
    features: ["20,000+ sq.m facility", "3D modeling & CAD", "Advanced fabrication", "Quality testing"]
  },
  {
    id: 2,
    title: "Overhauling & Refurbishing",
    description: "Major overhauling and refurbishing of fire trucks to restore operational performance and extend service life.",
    features: ["Complete restoration", "System upgrades", "Performance testing", "Extended service life"]
  },
  {
    id: 3,
    title: "Maintenance Services",
    description: "Annual Maintenance Contracts (AMC) for preventive and corrective maintenance of fire fighting equipment.",
    features: ["Preventive maintenance", "24/7 support", "Genuine spare parts", "Trained technicians"]
  },
  {
    id: 4,
    title: "Fire Protection Systems",
    description: "Comprehensive fire protection solutions including design, installation, and commissioning of fire alarm, detection, and suppression systems.",
    features: ["Design & consultancy", "System installation", "NFPA compliance", "Testing & commissioning"]
  }
];

export const fireProtectionSystems = [
  {
    category: "Fire Alarm & Detection",
    items: ["Smoke Detectors", "Heat Detectors", "Flame Detectors", "Fire Alarm Systems"]
  },
  {
    category: "Fire Extinguishing Systems",
    items: ["Water Type Extinguishers", "Foam Extinguishers", "CO2 Extinguishers", "Dry Powder Extinguishers"]
  },
  {
    category: "Fire Hydrant Systems",
    items: ["Hydrant Valves", "Hose Pipes & Reels", "Fire Pumps", "Piping Network"]
  },
  {
    category: "Fire Suppression Systems",
    items: ["CO2 Suppression", "FM-200 Systems", "Foam Suppression", "Sprinkler Systems"]
  }
];

export const clients = [
  {
    name: "Government of India",
    logo: "/images/92nhyq2y_image_8_-removebg-preview.png"
  },
  {
    name: "Ministry of Defence",
    logo: "/images/8g4ik7dh_image_9_-removebg-preview.png"
  },
  {
    name: "Indian Air Force",
    logo: "/images/o89qhu87_image_10_-removebg-preview.png"
  },
  {
    name: "Airports Authority of India",
    logo: "/images/j2eawpc9_Picture5.png"
  },
  {
    name: "Indian Coast Guard",
    logo: "/images/s4oazrhw_image_11_-removebg-preview.png"
  },
  {
    name: "Indian Navy",
    logo: "/images/qide9xnx_Picture4.png"
  },
  {
    name: "Research and Analysis Wing",
    logo: "/images/6xe7mjgk_image_12_-removebg-preview.png"
  },
  {
    name: "Maharashtra Airport Development Corporation",
    logo: "/images/5odl530z_image_13_-removebg-preview.png"
  },
  {
    name: "Directorate General of Civil Aviation",
    logo: "/images/7d07wo3e_image-4.png"
  },
  {
    name: "UNDP",
    logo: "/images/ydgs49lv_image_14_-removebg-preview.png"
  },
  {
    name: "Royal Government of Bhutan",
    logo: "/images/wk8c93hg_image_15_-removebg-preview.png"
  },
  {
    name: "Aerospace Research & Development",
    logo: "/images/z2dhk49a_image_16_-removebg-preview.png"
  },
  {
    name: "Government of Maldives",
    logo: "/images/7yp4jrtk_Picture3.png"
  }
];

export const slideshowImages = [
  "/images/k99lyi0o_ChatGPT_Image_May_29_2026_03_28_40_PM.png",
  "/images/sp8hud27_ChatGPT_Image_May_29_2026_03_30_43_PM.png",
  "/images/crwtecsj_IMG_6768.jpg",
  "/images/xqju90wm_DSC_0626.JPG",
  "/images/s2e0v52e_Gemini_Generated_Image_cp2il6cp2il6cp2i.png",
  "/images/6aruswgv_Third_page_pic.jpg",
  "/images/j77gykvs_PHOTO-2026-05-29-16-11-03.jpg",
  "/images/rzpkomis_Picture9.png",
  "/images/c3tv5ab8_WhatsApp_Image_2026-05-27_at_12.13.12.jpeg",
  "/images/m23ea33f_Picture18.jpg"
];

export const companyLogo = "https://images.unsplash.com/photo-1660323671848-928629deddca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxmaXJlJTIwdHJ1Y2t8ZW58MHx8fHwxNzgwMzA2MDA1fDA&ixlib=rb-4.1.0&q=85";

export const timeline = [
  { year: "1927", event: "Humble beginnings - Company founded" },
  { year: "1963", event: "Appointed representative for M/s Motokov-FTC (Czechoslovakia)" },
  { year: "1983", event: "Supplied over 500 crash fire tenders in collaboration with Tatra" },
  { year: "1988", event: "Bhartiya Caccialancia Fire Systems - Pioneered Smoke & Fire Detection Technology and Fire Hydrant and Sprinkler Suppression System in India" },
  { year: "1994", event: "Started Archana Airways - First scheduled airlines venture" },
  { year: "2004", event: "Started Ghibellines Security Solutions Limited" },
  { year: "2007", event: "Started Bhartiya Cryogas Limited" },
  { year: "2008", event: "Collaboration with Rosenbauer International" },
  { year: "2010", event: "Golden Jubilee with Indian Air Force" },
  { year: "2020", event: "250+ Rosenbauer ARFFV supplied" },
  { year: "2022", event: "Manufactured Bharat Panther: India's first 'Made in India' ARFFV" },
  { year: "2027", event: "Celebrating 100 Years of Excellence" }
];

export const whyChooseUs = [
  {
    title: "Legacy & Trust",
    description: "Nearly a century of excellence in fire and safety engineering with trusted government partnerships"
  },
  {
    title: "One-Stop Solution",
    description: "Comprehensive fire and safety solutions from vehicles to systems, maintenance to consultancy"
  },
  {
    title: "Make in India",
    description: "Committed to indigenous manufacturing and engineering excellence with world-class quality"
  },
  {
    title: "Advanced Technology",
    description: "State-of-the-art manufacturing with 3D modeling, modern infrastructure, and international standards"
  },
  {
    title: "Global Partnerships",
    description: "Collaboration with prestigious OEMs including Rosenbauer, Tatra, THT, Sancakli Itfaiye and Twindisc"
  },
  {
    title: "Expert Workforce",
    description: "500+ skilled professionals including engineers, technicians, and business experts"
  }
];